import React from 'react';
import '../../Default.css';


function Rules() {
    return (
      <>
        <div className="page-title">
          Pięć fundamentalnych zasad!
        </div>
        <div className='boxes-contener'>
            <div className='text-box'>
                <div className='text-box-accent'>
                    Druhno, Druhu! <br/>
                    Uczestnicząc w ŚDM reprezentujesz Polskę oraz Związek Harcerstwa Rzeczypospolitej, dlatego pamiętaj o:
                </div>
                <ul>
                  <li>kulturze osobistej</li>
                  <li>karności – wypełniaj polecenia swoich przełożonych, którzy dbają o Twoje bezpieczeństwo; zgłaszaj wszelkie wyjścia lub potrzebę oddalenia się od grupy</li>
                  <li>punktualności</li>
                  <li>zdrowiu - miej ze sobą nakrycie głowy, filtr przeciwsłoneczny, wodę</li>
                  <li>mundurze, aby był zawsze schludny i spełniam wymogi Regulaminu Mundurowego</li>
                </ul>
            </div>
        </div>
      </>
    );
}

export default Rules;
